/// CQ 20180531
/// 授权HTTP请求工具

import * as basicHttp from './basicHttp.js'
const base64 = require('../alioss/Base64.js')
const config = require('../config.js')

function getAccessToken() {
  // 获取access_token
  var access_token = uni.getStorageSync('access_token')
  if (!access_token) {
    return ''
  }
  else {
    return access_token
  }
}

function getIyanyiUser() {
  // 获取access_token
  var iyanyiUser = uni.getStorageSync('iyanyiUser')
  if (!iyanyiUser) {
    return ''
  }
  else {
    return iyanyiUser
  }
}

function getRefreshToken(){
  var refresh_token = uni.getStorageSync('refresh_token')
  if (!refresh_token) {
    return ''
  }
  else {
    return refresh_token
  }
}
function getTempToken() {
  var tempToken = uni.getStorageSync('temp_token')
  if (!tempToken) {
    return ''
  }
  else {
    return tempToken
  }
}

function authorization(t) {
  return t.startsWith('Bearer ') ? t : 'Bearer ' + t
}
export const getToken = function () {
  var tempToken = uni.getStorageSync('temp_token')
  if (!tempToken) {
    return ''
  } else {
    return tempToken
  }
}

export const get = function (url, data, header = {}) {
  var access_token = getAccessToken()
  if(access_token) {
    header =Object.assign(header, { "Authorization": authorization(access_token)})
    var iyanyiUser = getIyanyiUser()
    if(iyanyiUser && iyanyiUser.Id){
      // header =Object.assign(header, { "x-userid-header": iyanyiUser.Id})
      // header =Object.assign(header, { "x-user-name-header": iyanyiUser.Username})
      // header =Object.assign(header, { "x-user-phone-header": iyanyiUser.PhoneNumber})
      // header =Object.assign(header, { "x-memberid-header": iyanyiUser.MemberId})
      // header =Object.assign(header, { "x-na": new Date().getTime()})
    }
  }
  let clientId = uni.getStorageSync('clientId')
  if(data && data.webClientId) clientId = data.webClientId
  header =Object.assign(header, { "tenantId": clientId})
  if(url && (url.indexOf('user/login/c') >= 0 || url.indexOf('oauth/token') >= 0) || url.indexOf('loginByWeChatMP/c')>=0 || url.indexOf('loginByDouYinMP/c')>=0){
    // client:secret
    let clientSecretStr = clientId + ':' + config.clientSecret
    let clientSecretCode = base64.encode(clientSecretStr)
    header = Object.assign(header, { "Authorization": 'Basic ' + clientSecretCode})
  }
  return basicHttp.get(url, data, header)
}

export const post = function (url, data, header = {}) {
  var access_token = getAccessToken()
  if(access_token) {
    header =Object.assign(header, { "Authorization": authorization(access_token)})
    var iyanyiUser = getIyanyiUser()
    if(iyanyiUser && iyanyiUser.Id){
      // header =Object.assign(header, { "x-userid-header": iyanyiUser.Id})
      // header =Object.assign(header, { "x-user-name-header": iyanyiUser.Username})
      // header =Object.assign(header, { "x-user-phone-header": iyanyiUser.PhoneNumber})
      // header =Object.assign(header, { "x-memberid-header": iyanyiUser.MemberId})
      // header =Object.assign(header, { "x-na": new Date().getTime()})
    }
  }
  let clientId = uni.getStorageSync('clientId')
  if(data && data.webClientId) clientId = data.webClientId
  header =Object.assign(header, { "tenantId": clientId})
  if(url && (url.indexOf('user/login/c') >= 0 || url.indexOf('oauth/token') >= 0)|| url.indexOf('loginByWeChatMP/c')>=0 || url.indexOf('loginByDouYinMP/c')>=0){
    // client:secret
    let clientSecretStr = clientId + ':' + config.clientSecret
    let clientSecretCode = base64.encode(clientSecretStr)
    header = Object.assign(header, { "Authorization": 'Basic ' + clientSecretCode})
  }
  return basicHttp.post(url, data, header)
}

export default {
  getRefreshToken,
  getToken,
  get,
  post
}
